import { setAutoBidsMutationInstance, setBidsMutationInstance } from '../../graphql/mutations/grid/prices-wizard';
import { rumCounters } from '../../service/RUM/RUM';
import { GdSetAutoBidsInput, GdSetBidsInput, setAutoBidsMutation, setBidsMutation } from '../../typings/graphql-grid';
import { BaseMutationExecutor } from '../BaseMutationExecutor/BaseMutationExecutor';

export class PricesWizardMutationExecutor extends BaseMutationExecutor {
    public setBids(input: GdSetBidsInput, login: string): Promise<setBidsMutation> {
        return this.awaitExecute<setBidsMutation>(
            setBidsMutationInstance,
            input,
            login,
            {},
            rumCounters.backendPriceWizardBids
        );
    }

    public setAutoBids(
        input: GdSetAutoBidsInput,
        mcBannerInput: GdSetAutoBidsInput,
        login: string
    ): Promise<setAutoBidsMutation> {
        return this.awaitExecute<setAutoBidsMutation>(
            setAutoBidsMutationInstance,
            input,
            login,
            {},
            rumCounters.backendPriceWizardAutoBids,
            {
                mcBannerInput
            }
        );
    }
}
